import { DateTime } from 'luxon';

export const getLastMarketDay = (): { date: string; isToday: boolean } => {
  let time = DateTime.now();
  const hour = time.hour;
  if (hour < 9) {
    time = time.minus({ day: 1 });
  }
  const day = time.day;
  // Set Saturday/Sunday to Friday TODO: handle market holidays
  if (day === 0 || day === 6) {
    time.set({ day: 5 });
  }
  return {
    date: time.toISODate(),
    isToday: DateTime.now().equals(time),
  };
};

export const getNextMarketDay = (): { date: string; isToday: boolean } => {
  const time = DateTime.now();
  const day = time.day;
  // Set Saturday/Sunday to Friday TODO: handle market holidays
  if (day === 0 || day === 6) {
    time.set({ day: 1 });
  }
  return {
    date: time.toISODate(),
    isToday: DateTime.now().equals(time),
  };
};

export const barsPrepCandles = (candles: Array<any>, time_range: string): any => {
  const data = candles.map((c, n) => {
    c.open = Number(c.open);
    c.close = Number(c.close);
    c.y = c.close;
    c.high = Number(c.high);
    c.low = Number(c.low);
    c.date = c.dateTime;
    const date = DateTime.fromISO(c.dateTime);
    if (time_range === '1W' || time_range === '1M') {
      c.x = n + 1;
    } else {
      c.x = date.toSeconds() * 1000;
    }
    return c;
  });
  data.sort((a: any, b: any) => {
    return a.x > b.x ? 1 : -1;
  });
  return data;
};

export const barsFromTimeRange = (time_range: string): any => {
  const time = DateTime.now();
  switch (time_range) {
    case '1D':
      if (time.hour < 9) return time.minus({ days: 1 });
      return time;
    case '1W':
      return time.minus({ day: 7 });
    case '1M':
      return time.minus({ day: 30 });
    case '3M':
      return time.minus({ day: 90 });
    case '1Y':
      return time.minus({ year: 1 });
    case '5Y':
      return time.minus({ year: 5 });
    default:
      return time.minus({ day: 1 });
  }
};

export const barsIntervalFromTimeRange = (time_range: string, type = 'candle'): any => {
  if (type === 'candle') {
    switch (time_range) {
      case '1D':
        return '15m';
      case '1W':
        return '1h';
      case '1M':
        return '1D';
      case '3M':
        return '1W';
      case '1Y':
        return '1W';
      case '5Y':
        return '30D';
      default:
        return '1D';
    }
  } else {
    switch (time_range) {
      case '1D':
        return '5m';
      case '1W':
        return '1h';
      case '1M':
        return '1D';
      case '3M':
        return '1D';
      case '1Y':
        return '1D';
      case '5Y':
        return '1W';
      default:
        return '1D';
    }
  }
};
